module.exports = __webpack_public_path__ + "img/gmail.60e95a48.png";